import { render, staticRenderFns } from "./calendar-small.component.vue?vue&type=template&id=f44f487a&scoped=true"
import script from "./calendar-small.component.vue?vue&type=script&lang=js"
export * from "./calendar-small.component.vue?vue&type=script&lang=js"
import style0 from "./calendar-small.component.vue?vue&type=style&index=0&id=f44f487a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44f487a",
  null
  
)

export default component.exports